import axios from 'axios';
import { useCallback, useState } from 'react';
import { store } from '../factory';
import type { GuestBookInterface } from './interfaces';

interface UseGuestBookMessagesReturn {
  messages: GuestBookInterface.Message[];
  getGuestBookMessages: (eventID: string) => Promise<void>;
  loading: boolean;
  error: string | undefined;
}

export const useGuestBookMessages = (): UseGuestBookMessagesReturn => {
  const [messages, setMessages] = useState<GuestBookInterface.Message[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | undefined>(undefined);

  const { environment } = store.getState();

  const getGuestBookMessages = useCallback(
    async (eventID: string) => {
      if (!eventID) {
        return;
      }

      setLoading(true);
      setError(undefined);

      try {
        const { data } = await axios.request<{
          message: string;
          data: GuestBookInterface.Message[];
        }>({
          method: 'get',
          baseURL: environment.REST_URI,
          url: `api/v1/guest-book/messages/${eventID}`,
          headers: { 'Content-Type': 'application/json' }
        });

        setMessages(data.data);
      } catch (error_: unknown) {
        console.error('error comunication with rest_api?: ', error_);
        setError('Failed to fetch messages');
      } finally {
        setLoading(false);
      }
    },
    [environment.REST_URI]
  );

  return {
    messages,
    getGuestBookMessages,
    loading,
    error
  };
};
